'use client'

import {useRef, useState} from 'react'
import {Button, PodcastCard, PodcastCardProps, SlideshowNative, SmallText} from '@local/ui/components'
import ArrowSVG from '@local/assets/svgs/arrow.svg'
import {LinkInput} from '@local/types'
import {cx} from '@local/utils/cx'

export interface PodcastGridContentProps {
	surtitle: string
	description: string,
	cta: LinkInput
	entries: Array<PodcastCardProps>
}

export const PodcastGridContent = ({surtitle, description, cta, entries}: PodcastGridContentProps) => {
	const slideshowRef = useRef<HTMLElement>(null)
	const [activeIndex, setActiveIndex] = useState<number>(0)

	const scrollTo = (index) => {
		setActiveIndex(index)
		if (slideshowRef.current) {
			slideshowRef.current.scrollToIndex(index)
		}
	}
	const handlePrev = () => {
		if (activeIndex > 0) {
			const index = activeIndex - 1
			scrollTo(index)
		}
	}
	const handleNext = () => {
		if (activeIndex < entries.length - 1) {
			const index = activeIndex + 1
			scrollTo(index)
		}
	}

	return (
		<div className='flex lg-max:flex-col gutter-gap-1'>
			<div className='span-w-12 lg:span-w-5 margin-ml-1'>
				{surtitle && <SmallText textColor='grey-2'>{surtitle}</SmallText>}
				{description && (
					<p className='text-12  lg:text-14 leading-normal  font-[350]  tracking-snug  pt-11 pb-30'>{description}</p>
				)}
				{/* {cta && (
					<Button linkInput={cta} variant='primary' className='span-w-12 lg:span-w-3 uppercase mb-50 lg:mb-90'>{cta.label}</Button>
				)} */}

				<div className='flex gap-10 lg-max:hidden'>
					<Button
						small
						border
						onClick={handlePrev}
						label='Previous Slideshow Item'
						variant='secondary-transparent'
						disabled={activeIndex === 0}
						className={cx(
							'rounded-md w-38 h-38 px-0 disabled:bg-grey-1 disabled:text-black',
							activeIndex === 0 && 'opacity-50',
						)}>
						<ArrowSVG className='-rotate-180 w-6 h-9' />
					</Button>
					<Button
						small
						border
						onClick={handleNext}
						label='Next Slideshow Item'
						variant='secondary-transparent'
						disabled={activeIndex === entries.length - 1}
						className={cx(
							'rounded-md w-38 h-38 px-0 disabled:bg-grey-1 disabled:text-black',
							activeIndex === entries.length - 1 && 'opacity-50',
						)}>
						<ArrowSVG className='w-6 h-9' />
					</Button>
				</div>
			</div>
			<SlideshowNative
				disableObserver
				ref={slideshowRef}
				withDotNavigation
				dotNavigationClassName='lg-max:margin-px-1 lg:hidden mt-30'
				className='span-w-12-wider lg:span-w-7-wide gutter-gap-1 lg-max:scroll-pl-[var(--margin)] lg-max:margin-px-1 lg:margin-pr-1'>
				{entries.map((card, index) => (
					<PodcastCard key={index} {...card} isTall={index % 2 === 0} />
				))}
			</SlideshowNative>
		</div>
	)
}
